import { Role } from "../contract/shared/role.model";

export class Users {
  id: number = null;
  userId: number = null;
  tenantId: number = null;
  employeeId: string = null;
  status: number = null;
  firstName: string = null;
  middleName: null;
  lastName: string = null;
  address: string = null;
  countryId: number = null;
  emailAddress: string = null;
  password: string = null;
  contactNumber: string = null;
  profilePic: null;
  designation: string = null;
  organizationLevel: string = null;
  isFirstLogin: boolean = null;
  department: string = null;
  dateOfJoining: string = null;
  reportingManager: string = null;
  reportingManagerId: number = null;
  roleId: number = null;
  roleName: any;
  createdBy: string = null;
  createDate: Date = null;
  updatedBy: string = null;
  updateDate: Date = null;
}
